module.exports = __webpack_public_path__ + "static/media/index.1d9af13.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index.mp4
// module id = FH+8
// module chunks = 2